import React, { useState } from 'react';
import { Box, Menu, MenuItem, Avatar } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

// flags
import enFlag from '../assets/flags/en.png';
import deFlag from '../assets/flags/de.png';
import frFlag from '../assets/flags/fr.png';
import itFlag from '../assets/flags/it.png';
import esFlag from '../assets/flags/es.png';

const languages = [
  { code: 'EN', label: 'English', flag: enFlag },
  { code: 'DE', label: 'Deutsch', flag: deFlag },
  { code: 'FR', label: 'Français', flag: frFlag },
  { code: 'IT', label: 'Italiano', flag: itFlag },
  { code: 'ES', label: 'Español', flag: esFlag },
];

const LanguageSelector = ({
  selected,
  onChange,
}: {
  selected: string;
  onChange: (code: string) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (code: string) => {
    onChange(code);
    handleClose();
  };

  const selectedLanguage =
    languages.find((lang) => lang.code === selected) || languages[0];

  const isOpen = Boolean(anchorEl);

  return (
    <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
      <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          px: 1.5,
          py: 0.5,
          borderRadius: '999px',
          border: '0.3px solid #ccc',
          bgcolor: '#f9f9f9',
          boxShadow: 0.5,
          gap: 1,
          transition: 'background-color 0.2s',
          '&:hover': {
            bgcolor: '#f0f0f0',
          },
        }}
      >
        <ChevronLeftIcon
          sx={{
            color: 'black',
            transform: isOpen ? 'rotate(90deg)' : 'rotate(-90deg)',
            transition: 'transform 0.2s ease-in-out',
          }}
        />
        <Avatar
          src={selectedLanguage.flag}
          alt={selectedLanguage.code}
          sx={{ width: 24, height: 24 }}
        />
      </Box>

      <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
        {languages.map((lang) => (
          <MenuItem key={lang.code} onClick={() => handleSelect(lang.code)}>
            <Avatar
              src={lang.flag}
              alt={lang.code}
              sx={{ width: 24, height: 24, mr: 1 }}
            />
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;